import './index.css'
import '../../../i18n'
import {useMemo} from "react";
import {useTranslation} from "react-i18next";

function Introduction() {
    const {t, i18n} = useTranslation()

    const list = useMemo(() => {
        return [
            {title: t('digitalQuestion1'), desc: t('digitalAnswer1')},
            {title: t('digitalQuestion2'), desc: t('digitalAnswer2')},
        ]
    }, [t]);
    const desList = useMemo(() => {
        return [
            {desc: t('guardianDes1')},
            {desc: t('guardianDes2')},
            {desc: t('guardianDes3')},
            {desc: t('guardianDes4')},
            {desc: t('guardianDes5')},
        ]
    }, [t]);
    return (
        <>
            <div className="introduction">
                {list.map((item, index) => {
                    return (
                        <div key={index} className="list-item">
                            <h3 className="title">{t(item.title)}</h3>
                            <p className="desc">{t(item.desc)}</p>
                        </div>
                    )
                })}
            </div>
               <h4 style={{textAlign:'left',paddingLeft:'32px',width:'100%'}}>{t('guardianDes')}</h4>
               {desList.map((item, index) => {
                   return (
                       <div key={index} className="list-item">
                           <p className="desc">{t(item.desc)}</p>
                       </div>
                   )
               })}
        </>
    );
}

export default Introduction;
